











































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { getCurrentTime } from "@/utils/base";
import {
  SaveExam,
  GetExamResult,
  GetCommit,
  GetExamDetail,
} from "@/request/common";
import QuestionImg from "@/components/question/question-img.vue";
import QuestionSelect from "@/components/question/question-select.vue";
import QuestionCard from "@/components/question/question-card.vue";
import Countdown2 from "@/components/countdown2.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    QuestionImg,
    QuestionSelect,
    QuestionCard,
    Countdown2,
  },
})
export default class Name extends Vue {
  private time: any = 0;
  private questionIndex: any = null;
  private showAnswer: any = false;
  private ifShowRusult: any = false;
  private ifShowAutoRusult: any = false;
  private ifShowLeave: any = false;
  private ifEdit: any = true;
  private maxH: any = null; // 图片的最大高度
  private data: any = {};
  private result: any = {};
  private type: any = "";
  private ifReading: any = false; // 脉图设备是否已存在
  private ifOpen: any = false; // 是否打开过脉的设备
  private get user() {
    return this.$store.state.user;
  }
  private get systemInfo() {
    return this.$store.state.systemInfo;
  }
  private async changeMainDevice() {
    // 如果支持设备脉，需要调取exe调整设备脉
    console.log("切换设备");
    console.log(this.questionIndex);
    console.log(this.data["questions"][this.questionIndex]);
    const res = this.data["questions"][this.questionIndex];
    if (this.systemInfo.SETTING.iFHasDevicePulse && res["类别"] == "脉") {
      const option = res.data[0].options.find(
        (item: any) => item.value === res.data[0].correct
      );
      const val: any = option ? option.label : "";
      if (this.ifReading) {
        console.log(val, "control_hand", "start");
        const result = await window.electronMyAPI.changePulse(
          val,
          "control_hand",
          "start"
        );
        console.log(result);
        const loading2 = this.$loading({
          lock: true,
          text: "脉象切换中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        if (result) {
          this.ifOpen = true;
          loading2.close();
          console.log("返回值：" + result);
        }
      } else {
        console.log("检查", "check_hand", "检查");
        const checkResult = await window.electronMyAPI.changePulse(
          "检查",
          "check_hand",
          "检查"
        );
        console.log(checkResult);
        const loadingCheck = this.$loading({
          lock: true,
          text: "设备检查中……",
          spinner: "el-icon-loading",
          customClass: "loadClass",
          background: "rgba(255, 255, 255, 0.7)",
        });
        if (checkResult) {
          if (checkResult == "success") {
            this.ifReading = true;
            loadingCheck.close();
            console.log("返回值：" + checkResult);
            console.log(val, "control_hand", "start");
            const result = await window.electronMyAPI.changePulse(
              val,
              "control_hand",
              "start"
            );
            console.log(result);
            const loading2 = this.$loading({
              lock: true,
              text: "脉象切换中……",
              spinner: "el-icon-loading",
              customClass: "loadClass",
              background: "rgba(255, 255, 255, 0.7)",
            });
            if (result) {
              this.ifOpen = true;
              loading2.close();
              console.log("返回值：" + result);
            }
          } else {
            loadingCheck.close();
            alert("设备不存在");
          }
        }
      }
    }
  }
  private jiexi() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params: any = {
      qts: this.data["questions"][this.questionIndex].data,
      template_type: this.data["questions"][this.questionIndex]["类别"],
    };
    GetCommit(this, params, loading)
      .then((res: any) => {
        const d: any = JSON.parse(JSON.stringify(this.data.questions));
        d[this.questionIndex]["评语"] = res;
        d[this.questionIndex].ifShowAnswerJiexi = true;
        this.data.questions = d;
        this.$forceUpdate();
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private goResult() {
    this.$router.push({
      path: "/main/shixun/exam-condition",
      query: {
        id: this.result.exam_result_id,
        source: "exam",
      },
    });
  }
  private save(type: any) {
    // this.ifEdit = false;
    // if (type) {
    //   this.ifShowAutoRusult = true;
    // } else {
    //   this.ifShowRusult = true;
    // }
    //需要删除加入的控制字段
    const d = JSON.parse(JSON.stringify(this.data));
    d.questions.forEach((ele: any) => {
      delete ele.ifSelect;
      delete ele.ifShowEdit;
      delete ele.ifShowCorrect;
      delete ele.ifShowAnswer;
      delete ele.ifShowAnswerBtn;
      delete ele.ifShowAnswerResult;
    });
    d["交卷时间"] = getCurrentTime("yyyy-MM-dd HH:mm:ss");
    if (!d.banji_id) {
      d.banji_id = this.user["所属班级"].banji_id;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    SaveExam(this, d, loading)
      .then((res: any) => {
        loading.close();
        this.getResult(res).then((result: any) => {
          this.result = result;
          this.ifEdit = false;
          this.ifShowLeave = false;
          if (type) {
            this.ifShowAutoRusult = true;
          } else {
            this.ifShowRusult = true;
          }
        });
      })
      .catch(() => {
        loading.close();
      });
  }
  private updata() {
    // 自动交卷
    this.save("auto");
  }
  private countHeight() {
    const box = (this.$refs.imgBox as any).offsetHeight;
    this.maxH = box;
  }
  private IndexChange(index: any) {
    this.questionIndex = index;
    this.changeMainDevice();
  }
  private changeSelect(val: any) {
    this.data.questions[this.questionIndex].ifSelect = val;
  }
  private goBefore() {
    if (this.questionIndex == 0) {
      this.$message.warning("已经是第一题了");
      return;
    }
    this.questionIndex--;
    this.changeMainDevice();
  }
  private goNext() {
    if (this.questionIndex == this.data.questions.length - 1) {
      this.$message.warning("已经是最后一题了");
      return;
    }
    this.questionIndex++;
    this.changeMainDevice();
  }
  private getData() {
    if (!this.data.exam_id) {
      this.$message.success("id参数缺失");
      return;
    }
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      params: {
        exam_id: this.data.exam_id,
      },
    };
    GetExamDetail(this, params, loading)
      .then((res: any) => {
        // 初始化参数，根据页面需求初始化
        // ifSelect 是否答题
        // ifShowEdit 是否可以编辑
        // ifShowCorrect 是否显示正确答案
        // ifShowAnswer 是否显示答案
        // ifShowAnswerBtn 是否显示答案按钮
        // ifShowAnswerResult 是否显示答案结果
        res.questions.forEach((element: any) => {
          element.ifSelect = false;
          element.ifShowEdit = true;
          element.ifShowCorrect = false;
          element.ifShowAnswer = true;
          element.ifShowAnswerBtn = false;
          element.ifShowAnswerResult = false;
          element.data.forEach((ele: any) => {
            if (ele.type == "多选" && !ele.answer) {
              ele.answer = [];
            }
          });
        });
        res["启动时间"] = getCurrentTime("yyyy-MM-dd HH:mm:ss");
        this.data = res;
        this.questionIndex = 0;
        this.changeMainDevice();
        // 倒计时处理，如果是模拟考试，只需传入30分钟，如果是正式考试，需要把考试时长和考试的时间做对比，
        const time = this.data["时长"] * 60 * 1000;
        if (this.type == "模拟") {
          this.time = time;
        } else if (this.type == "正式") {
          // 如果结束时间-当前时间小于时长，则需根据结束时间重新计算，否则只需取时长
          const now = new Date().getTime();
          const last = new Date(this.data["结束时间"]).getTime();
          if (last - now < time) {
            this.time = last - now;
          } else {
            this.time = time;
          }
        }
        this.countHeight();
        loading.close();
      })
      .catch(() => {
        loading.close();
      });
  }
  private getResult(id: any) {
    return new Promise((resolve, reject) => {
      const loading = this.$loading({
        lock: true,
        text: "加载中……",
        spinner: "el-icon-loading",
        customClass: "loadClass",
        background: "rgba(255, 255, 255, 0.7)",
      });
      const params: any = {
        params: {
          exam_result_id: id,
        },
      };
      GetExamResult(this, params, loading)
        .then((res: any) => {
          this.result = res;
          resolve(res);
        })
        .catch(() => {
          loading.close();
          reject();
        });
    });
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    if (this.ifOpen) {
      console.log("关闭脉设备");
      console.log("停止", "control_hand", "stop");
      const result = window.electronMyAPI.changePulse(
        "停止",
        "control_hand",
        "stop"
      );
      console.log(result);
    }
    if (this.ifEdit) {
      this.ifShowLeave = true;
      next(false);
    } else {
      // 禁掉浏览器的点击右键出现菜单功能
      document.oncontextmenu = function () {
        return true;
      };
      next(true);
    }
  }

  private mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.data.exam_id = this.$route.query.id;
    }
    this.getData();
    window.onresize = () => {
      //屏幕尺寸变化就重新计算时间轴
      return (() => {
        this.countHeight();
      })();
    };
    // 禁掉浏览器的点击右键出现菜单功能
    document.oncontextmenu = function () {
      return false;
    };
  }
}
